import { ClipboardList, Wrench, BarChart3, Sparkles } from "lucide-react";

export const PILLARS = [
  {
    id: "manage",
    icon: ClipboardList,
    name: "Manage",
    summary: "Properties, tenants, leases, vendors and day-to-day operations.",
    headline: "Run every property from one place.",
    copy: "Keep property records, tenants, leases, vendors and documents together, so your team works from the same information.",
    capabilities: ["Property records", "Tenants & leases", "Vendors", "Documents"],
    glimpse: "occupancy",
  },
  {
    id: "maintain",
    icon: Wrench,
    name: "Maintain",
    summary: "Stay ahead of maintenance through structured requests, inspections and preventive care.",
    headline: "Stay ahead of problems instead of reacting to them.",
    copy: "Structured requests, inspections and preventive schedules keep small issues from becoming expensive ones.",
    capabilities: ["Maintenance requests", "Inspections", "Preventive schedules", "Maintenance history"],
    glimpse: "maintenance",
  },
  {
    id: "understand",
    icon: BarChart3,
    name: "Understand",
    summary: "Bring financial and operational information together for greater portfolio visibility.",
    headline: "Know how each property is really performing.",
    copy: "Financial and operational information side by side, from a single building to the whole portfolio.",
    capabilities: ["Income & expenses", "Occupancy", "Portfolio overview", "Reporting"],
    glimpse: "financial",
  },
  {
    id: "optimize",
    icon: Sparkles,
    name: "Optimize",
    summary: "Turn property data into actionable intelligence that supports better decisions.",
    headline: "Let your portfolio tell you what deserves attention.",
    copy: "ANFORD Insights surfaces risks, patterns and opportunities across your properties, with a recommended next step.",
    capabilities: ["Alerts", "Priorities", "Recommendations"],
    glimpse: "alert",
    link: { label: "About ANFORD Insights", to: "/insights" },
  },
];
